import React from 'react'
import { Row, Col } from 'reactstrap'
import { WhiteBox } from '@/components/Layout'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import Name from '@/components/Name'
import { formatDate } from '@/utils/dateUtilities'

function IndividualDetail (props) {
  const { individual, headerText } = props

  return (
    <WhiteBox header={headerText || ''} dataCy='IndividualDetailHeader'>
      <Row>
        <Col lg='6'>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.Name' /></InfoLabel>
            <InfoContent>{individual.firstName}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.Surname' /></InfoLabel>
            <InfoContent>{individual.surname}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.FatherName' /></InfoLabel>
            <InfoContent>{individual.fatherName}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.GrandfatherName' /></InfoLabel>
            <InfoContent>{individual.grandfatherName}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.GreatGrandfatherName' /></InfoLabel>
            <InfoContent>{individual.greatGrandfatherName}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.MotherName' /></InfoLabel>
            <InfoContent>{individual.motherName}</InfoContent>
          </InfoRow>
        </Col>
        <Col lg='6'>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.MotherFatherName' /></InfoLabel>
            <InfoContent>{individual.motherFatherName}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.MotherGrandfatherName' /></InfoLabel>
            <InfoContent>{individual.motherGrandfatherName}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.BirthDate' /></InfoLabel>
            <InfoContent>{formatDate(individual.birthDate)}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.BirthPlace' /></InfoLabel>
            <InfoContent>{individual.birthPlace}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Individuals.Nationality' /></InfoLabel>
            <InfoContent><Name data={individual.nationality} /></InfoContent>
          </InfoRow>
        </Col>
      </Row>
    </WhiteBox>
  )
}

export default IndividualDetail



// WEBPACK FOOTER //
// ./src/components/userProfile/individualDetail.js